import React from 'react';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { Tooltip } from '@saucelabs/ds-tooltip';

import { Scalars } from '../../graphql/__generated__/graphql';

type Props = {
  data: Scalars['Datetime']
  mode?: TimeMode
  modeHover?: TimeMode
}

export enum TimeMode {
  DATE = 'DATE',
  SHORT = 'SHORT',
  UTC = 'UTC',
}

export const convertToMs = (data: Scalars['Datetime']) => new Date(data).getTime();
export const convertToSec = (data: Scalars['Datetime']) => convertToMs(data) / 1000;

export const formatDate: Record<TimeMode, (data: Scalars['Datetime']) => string> = {
  [TimeMode.DATE]: (data) => format(convertToMs(data), "MMM do, yyyy 'at' h:mma"),
  [TimeMode.SHORT]: (data) => format(convertToMs(data), "MMM do 'at' h:mma"),
  [TimeMode.UTC]: (data) => formatInTimeZone(convertToMs(data), 'UTC', "yyyy'-'MM'-'dd HH:mm:ss z"),
};

const DateLabel: React.FC<Props> = ({ data, mode = TimeMode.DATE, modeHover = TimeMode.UTC }) => {
  const date = formatDate[mode](data);
  const dateHover = formatDate[modeHover](data);
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div onClickCapture={stopPropagation}>
      <Tooltip
        placement="top"
        title={dateHover}
      >
        <div className="flex text-gray-600 font-normal">
          <span className="flex-shrink-0 whitespace-nowrap">
            {date}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

export default DateLabel;
